<template>
    <progress-bar
            :options="options"
            :value="value"
    />
</template>

<script>
    import Vue from 'vue'
    import ProgressBar from 'vuejs-progress-bar'
    Vue.use(ProgressBar)
    export default {
        name: 'Progress',
        props: ['interval'],
        data () {
            var options = {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#2dbd2d',
                    backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                    width: 445,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            }
            return {
                value: 1,
                inputTextValue: '',
                options: options,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted(){
            this.progressDelay()
        },
        methods: {
            progressDelay: function(){
                var numberOfTimes = ''
                var delay = ''
                var $this = this
                if(!$this.interval){
                    $this.interval = 300
                }
                if($this.value === 1){
                    numberOfTimes = 98
                    delay = $this.interval
                } else {
                    numberOfTimes = 100 - this.value
                    delay = 10
                }
                for (let i = 0; i < numberOfTimes; i++) {
                    setTimeout( function () {
                        if($this.value < 100){
                            $this.value = $this.value + 1
                        }
                    }, delay * i)
                }
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #progress-bar-line {
        max-width: 445px;
    }
</style>



// WEBPACK FOOTER //
// src/components/include/Progress.vue